
/**
 * @fileOverview MediaGallery module definition
 * @author a2b86zz
 * @modified 03/13/2014
 **/
(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('kungfu/MediaGrid/MediaGallery',['require','jquery','GlobalEventDispatcher','GlobalResizeListener','controllers/ModalLaunchController','kungfu/MediaGrid/ImageGalleryView','lib/Util'],function(require) {
        var  $ = require('jquery'),
		GlobalEventDispatcher = require('GlobalEventDispatcher'),
        GlobalResizeListener = require('GlobalResizeListener'),
        ModalLaunchController = require('controllers/ModalLaunchController'),
        CarouselView = require('kungfu/MediaGrid/ImageGalleryView'),
		Util = require('lib/Util'),
        url = 'https://admin.brightcove.com/js/BrightcoveExperiences.js',
        body = document.getElementsByTagName('body')[0],
        script = document.createElement('script'),
        player, expId , bcMod, APIModules, firstVid, videoPlayer,
        mediaGallery;

        $.getScript(url)
        .done(function() {
            //Gobal call to Brightcove
            brightcove.createExperiences();
        });

        require(['domReady!'], function (doc) {
           //Fires upon DOM Ready to initialize component
            $('.js-MediaContainer').each(function (i,element) {
                new MediaGallery($(element));
			});
        });


        /**
         * A sample view script. Reveals a message using a card-flip animation.
         *
         * @class MediaGallery
         * @param {jQuery} $element A reference to the containing DOM element.
         * @constructor
         */
        var MediaGallery = function($element, expId) {
            /**
             * A reference to the containing DOM element.
             *
             * @default null
             * @property $element
             * @type {jQuery}
             * @public
             */
			this.$element = $element;			

			this.$imgTriggers = this.$element.find($('.js-Img-trigger'));
            this.$mediaGallery = this.$element.find($('.js-MediaGallery'));
            this.$mediaImages = undefined;
            this.$galleryCarousel = undefined;
            this.$galleryList = undefined;
            this.$galleryListItem = undefined;

            this.$galleryCarouselMob = undefined;
            this.$galleryListMob  = undefined;
            this.$galleryListItemMob  = undefined;

			this.$videoContainer = this.$element.find($('.js-Media-Video'));
            this.videourl ='';

            this.$lightBox = this.$element.find($('.js-modalTrigger'));

            this.thumbnailControllerContainerId = undefined;
            this.mobileThumbnailContollerContainerId = undefined;
            this.heroCarouselAlt = undefined;
            this.heroCarouselAltController = undefined;
            this.heroCarouselAltControllerMobile = undefined;

            this.isEnabled = false;
            this.settings ={};
            this.context = '';
            this.experienceId = '';

            /**
             * The global instance of an event dispatcher, used to subscribe to or publish events of global interest
             *
             * @default GlobalEventDispatcher.getEventDispatcher()
             * @property GlobalEventDispatcher
             * @type {jQuery}
             */
            this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher();

            /**
             * The global instance of an event dispatcher, used to subscribe to or publish events of global interest
             *
             * @default GlobalResizeListener.getResizeListener()
             * @property GlobalResizeListener
             * @type {jQuery}
             */
            this.globalResizeListener = GlobalResizeListener.getResizeListener();
			
            this.init();
        };

        /**
         * Initializes the UI Component View.
         * Runs a single setupHandlers call, followed by createChildren and layout.
         * Exits early if it is already initialized.
         *
         * @method init
         * @returns {MediaGallery}
         * @private
         */
        MediaGallery.prototype.init = function() {
			this.context = this.globalResizeListener.getCurrentContext();
            this.setOptions()
                .createChildren();

            $msg('expId '+ this.experienceId);
            return this;
        };

        MediaGallery.prototype.setOptions = function () {
            var defaults = {
                video_url : '/apxy/proxy?urlAlias=BC_Celum_Ext_PROD_P&playlist_id=',
                video_bc_playerid : '3259523391001',
                video_bc_playerkey : 'AQ~~,AAACZYoKPBk~,2uj6FbDasd8OMrsDacy0No7Kxox9TlfS',
                video_bc_playList : '3875095800001'
            };
            var options = {
                video_url : this.$videoContainer.attr('data-video_url'),
                video_bc_playerid : this.$videoContainer.attr('data-video_bc_playerid'),
                video_bc_playerkey : this.$videoContainer.attr('data-video_bc_playerkey'),
                video_bc_playList : this.$videoContainer.attr('data-video_bc_playList')
            };

            this.settings = $.extend({}, defaults, options);    //merge defaults with data-options object

            $debug('     Tags Options ', 'media');
            $debug('     HTML data-options Settings: ' + $printObj(options),'media');
            $debug('     Default Settings: ' + $printObj(defaults),'media');
            $msg('     Combined Settings: ' + $printObj(this.settings),'media');

            this.videourl = this.settings.video_url + this.settings.video_bc_playList;

            return this;
        };

        MediaGallery.prototype.createChildren = function () {
            var videoObjvar = '', videoObjvar, mediaGallery= this, rdnum = this.getRandomInt(1,10000);
            
            this.$mediaImages = this.$mediaGallery.find($('.js-Media'));
            this.$galleryCarousel = this.$mediaImages.find($('.js-galleryCarousel-alt'));
            this.$galleryList = this.$galleryCarousel.find($('.js-galleryList'));
            this.$galleryListItem = this.$galleryList.children();

            this.$galleryCarouselMob = this.$mediaImages.find($('.js-galleryCarousel-mobile-alt'));
            this.$galleryListMob = this.$galleryCarouselMob.find($('.js-galleryList'));
            this.$galleryListItemMob = this.$galleryListMob.children();

            if (this.$videoContainer.length === 0) {
                this.setContent()
                    .setupHandlers()
                    .enable()
                    .resizeCheck();
            }
            else {
                this.loadVideos();
            };


            return this;
        };
        		
        /**
         * Binds the scope of any handler functions.
         * Should only be run on initialization of the view.
         *
         * @method setupHandlers
         * @returns {MediaGallery}
         * @private
         */
        MediaGallery.prototype.setupHandlers = function() {
            this.onClickHandler = this.onClick.bind(this);
			this.eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.CONTEXT_CHANGE, this.resizeCheck.bind(this));
			
            return this;
        };

       		
		MediaGallery.prototype.resizeCheck = function() {
			var closeClass;
			//if (this.isEnabled === true) {
                this.context = this.globalResizeListener.getCurrentContext();
			//}				 	
			return this;
		};

        MediaGallery.prototype.setContent = function() {
            var self = this, imgContent;
             if (this.$videoContainer.length === 0) {
                imgContent = this.$mediaImages.html();
            }
            else {
                imgContent = this.$videoContainer.html();
            }
            self.$lightBox.find($('.MMM--bodyCopy')).html(imgContent);
            this.$mediaImages.find($('.MMM--galleryThumbLink')).attr('tabindex','-1');
            return this;
        };

        MediaGallery.prototype.loadVideos = function() {
            var self = this, randomId = this.getRandomInt(1,100);

            $.ajax({
                url: this.videourl,
                dataType : 'json',
                success: function(data) {
                    var videos = data.videos,
                    firstVid = videos[0].id,
                    htmlStr='', durMinutes, durSeconds, itemNum;

                    htmlStr += '<div class="MMM--gallery-thumbContainer js-galleryCarousel-alt MMM--isNotOnMobile" id="js-heroCarousel'+ randomId + '"  data-is-flexible="true" >' +
                        '<ul class="MMM--galleryList js-galleryList" >';
                    for(var i=0; i<videos.length; i++){
                        if (i < 5) {
                            htmlStr += '<li>' +  '<span>' + videos[i].name + '<span> </li>';
                            /*
                            itemNum = i +1;
                            // time not used currently storing for future requirements
                            //durMinutes = Math.floor(videos[i].length/60000);
                            //durSeconds = Math.floor((videos[i].length%60000)/1000);

                            htmlStr += '<li class="MMM--galleryListItem js-galleryListItem" data-imageid="Tile-' + randomId + '-' + itemNum + '" id="Tile-' + randomId + '-' + itemNum + '" > ' ;
                            //videos[i].id + '">';
                            //videoObjvar +
                            htmlStr += '<div class="mix-MMM--fontSmall js-VideoTile"> <div class="MMM--Img-content js-Img-content"> <div class="MMM--hdg mix-MMM--hdg_spaced MMM--hdg_1">' +
                                videos[i].name + '</div>' ;
                            //htmlStr += '<div> <div data-src="' + videos[i].videoStillURL + '">' + '<img src="' + videos[i].videoStillURL + '" />' +
                            //    '</div>' +
                            //    '</div>  ' +
                                //'<div class="MMM--wysiwyg"> <p> ' + videos[i].shortDescription +'</p> </div>' +
                             htmlStr += '</div> </div> </li>';
                             */
                        }
                    }
                    htmlStr += '</ul> </div>';
                     /*
                    htmlStr += '<div class="MMM--galleryNavigationContainer_carousel MMM--isNotOnMobile">' +
                        '<div id="js-gallery-thumbnailSlider" >' +
                            '<div class="MMM--gallery-thumbList MMM--galleryList_thumb">' +
                                '<ul class="js-gallery-Thumbnails-links" id="js-gallery-Thumbnails-links-'+ randomId + '">';
                    for(var i=0; i<videos.length; i++){
                        while (i < 6) {
                            htmlStr += '<li class="MMM--galleryList-thumb-item js-gallery-carouselNavigation" id="thumbCarouselItem1">' +
                                        '<a href="#Tile-' + randomId + '-' + itemNum + '" class="MMM--galleryThumbLink">' +
                                        '<div class="MMM--gallery-thumb-Figure"> <div class="MMM--galleryFigure-mask "> ' +
                                        'Now Playing' +'</div>' + '<img src="' + videos[i].thumbnailURL + '">' + ' class="MMM--galleryListFigure-img" />' +
                                        '</div> </a> </li>';
                        }
                    }
    */
                    self.$videoContainer.html(htmlStr);

                    /*
                    self.$thumnailTriggers = self.$videoList.find($('.MMM--videoThumb'));
                    self.$thumnailTriggers.on('click', function (event) {
                        event.preventDefault();
                        self.onClickHandler($(this));
                    });
*/
                },
                error: function(errorThrown) {
                    $debug('err '+errorThrown);
                }
            });
            return this;
        };

        MediaGallery.prototype.getVideos = function() {
            var self = this;
            player = brightcove.api.getExperience(self.experienceId);
            APIModules = brightcove.api.modules.APIModules;
            bcMod = player.getModule(brightcove.api.modules.APIModules.VIDEO_PLAYER);
            //bcMod.loadVideoByID(videos[0].id );
            bcMod.play();
            self.resizeCheck();
        }

        /**
         * Enables the component.
         * Performs any event binding to handlers.
         * Exits early if it is already enabled.
         *
         * @method enable
         * @returns {MediaGallery}
         * @public
         */
		MediaGallery.prototype.enable = function() {
			var self = this;
			$debug('    enable '+this.isEnabled , 'MediaGallery');
			if (this.isEnabled) {
                return this;
            }
            this.isEnabled = true;

			this.$imgTriggers.on('click', function (event) {
                self.onClickHandler($(this));
			});
            /*
            this.$videoTriggers.on('click', function (event) {
                self.onClickHandler($(this));
            });
            */
			return this;
		};

        /**
         * Disables the component.
         * Tears down any event binding to handlers.
         * Exits early if it is already disabled.
         *
         * @method disable
         * @returns {MediaGallery}
         * @public
         */
        MediaGallery.prototype.disable = function() {
            if (!this.isEnabled) {
                return this;
            }
            this.isEnabled = false;

            return this;
        };

        //////////////////////////////////////////////////////////////////////////////////
        // EVENT HANDLERS
        //////////////////////////////////////////////////////////////////////////////////

        /**
         * onClick handler.
         * Alters color upon click of the element.
         *
         * @method onClick
         * @param e {Event} JavaScript event object.
         * @private
         */
        MediaGallery.prototype.onClick = function(e) {
            var self = this;
        	this.resizeCheck();
        	//$msg('click ' + $(e).attr("class"));
        	if ($(e).hasClass('js-Img-trigger')) {
                this.getImageContent($(e));
            }
        };

        MediaGallery.prototype.getImageContent = function(elem) {
            var self = this, activeId = elem.attr('data-tileId'), imgContent = '', carouselelem, carouselelemId;

            if (this.context === 'smallContext') {
                 carouselelem = this.$galleryCarouselMob;
                 carouselelemId = '#' + carouselelem.attr('id');
                 $msg('in getImageContent carouselelemId '+carouselelemId);
                 self.$galleryListItemMob.each(function(ele) {
                    $msg('in getImageContent data-imageid '+$(this).attr('data-imageid') + ' id '+$(this).attr('id'));
                    if ($(this).attr('data-imageid') === activeId) {
                        self.heroCarouselAlt = new CarouselView(carouselelemId, self, $(this).attr('id'));
                    }
                });
            }
            else {
                 carouselelem = this.$galleryCarousel;
                 carouselelemId = '#' + carouselelem.attr('id');

                 self.$galleryListItem.each(function(ele) {
                    $msg('data img id ' + $(this).attr('data-imageid') + ' activeId ' + activeId);
                    if ($(this).attr('data-imageid') === activeId) {
                        self.heroCarouselAlt = new CarouselView(carouselelemId, self, $(this).attr('id'));
                    }
                });
            }
        };

        MediaGallery.prototype.getRandomInt = function(min, max) {
          return Math.floor(Math.random() * (max - min)) + min;
        }

        /*
        MediaGallery.prototype.getBCUrl = function(elem,id) {
            var self =this;
        };
        */
        window.onTemplateLoad = function (experienceId) {
            mediaGallery.experienceId = experienceId;
            $msg('on onTemplateLoad '+ mediaGallery.experienceId);
            mediaGallery.loadVideos();
            /*.setContent()
                .setupHandlers()
                .enable()
                .resizeCheck();*/
        };
    });

}(MMMRequire));